exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-content{width:100%;height:calc(100vh - 191px);display:flex;flex-direction:column;align-items:center;padding-top:10rem}.image-404,.image-404-content{width:822px;height:411px}.image-404{object-fit:contain}.error-text{height:32px;font-size:28px;color:#000;margin:20px 0}.error-home-btn,.error-text{font-family:NanumBarunGothicOTF;text-align:center}.error-home-btn{width:416px;height:64px;border-radius:3px;box-shadow:0 3px 10px 0 rgba(75,116,255,.6);background-color:#4b74ff;font-size:20px;line-height:64px;outline:none;color:#fff;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2eb58597","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/Error404.vue
// module id = 309
// module chunks = 0